export default "__VITE_ASSET__5560791b__"